import { BsCheckLg } from "react-icons/bs";

const STEPS = [
  { label: "Draft", key: "draft" },
  { label: "Submitted", key: "submitted" },
  { label: "Manager Review", key: "manager_review" },
  { label: "Owner Review", key: "owner_review" },
  { label: "Approved", key: "approved" },
];

const stepIndexForStatus = {
  draft: 0,
  pending_approval: 1,
  pending_manager_approval: 1,
  pending_owner_approval: 2,
  approved: 4,
  processing: 4,
  partially_fulfilled: 4,
  fulfilled: 4,
};

// Map completed step thresholds (steps strictly before the active one are done)
const completedUpTo = {
  draft: -1,
  pending_approval: 0,
  pending_manager_approval: 0,
  pending_owner_approval: 2,
  approved: 3,
  processing: 3,
  partially_fulfilled: 3,
  fulfilled: 4,
};

const RequisitionStepper = ({ status }) => {
  if (status === "rejected") {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg px-5 py-3 flex items-center gap-3 mb-6">
        <span className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
        <p className="text-sm font-semibold text-red-700">Requisition Rejected</p>
      </div>
    );
  }

  if (status === "cancelled") {
    return (
      <div className="bg-gray-100 border border-gray-200 rounded-lg px-5 py-3 flex items-center gap-3 mb-6">
        <span className="w-3 h-3 rounded-full bg-gray-400 flex-shrink-0" />
        <p className="text-sm font-semibold text-gray-600">Requisition Cancelled</p>
      </div>
    );
  }

  const activeStep = stepIndexForStatus[status] ?? 0;
  const doneUpTo = completedUpTo[status] ?? -1;

  return (
    <div className="bg-white rounded-lg shadow p-4 mb-6">
      <div className="flex items-center justify-between relative">
        {/* connecting line */}
        <div className="absolute top-4 left-0 right-0 h-0.5 bg-gray-200 z-0" />

        {STEPS.map((step, index) => {
          const isDone = index <= doneUpTo;
          const isActive = index === activeStep && !isDone;
          const isFuture = !isDone && !isActive;

          return (
            <div key={step.key} className="flex flex-col items-center z-10 flex-1">
              <div
                className={`
                  w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold border-2 transition-all
                  ${isDone ? "bg-green-500 border-green-500 text-white" : ""}
                  ${isActive ? "bg-primary border-primary text-white ring-4 ring-blue-100" : ""}
                  ${isFuture ? "bg-white border-gray-300 text-gray-400" : ""}
                `}
              >
                {isDone ? <BsCheckLg className="text-xs" /> : index + 1}
              </div>
              <p
                className={`mt-2 text-xs text-center leading-tight
                  ${isDone ? "text-green-600 font-medium" : ""}
                  ${isActive ? "text-primary font-semibold" : ""}
                  ${isFuture ? "text-gray-400" : ""}
                `}
              >
                {step.label}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RequisitionStepper;
